export const FACEBOOK_LINK = "https://www.facebook.com/namitoyshop1";
export const DISCORD_LINK = "https://discord.gg/caoxbanzai";
export const GROUP_LINK = "https://www.facebook.com/groups/2489686291424735"